export default "__VITE_ASSET__24923af0__"